import { useEffect } from 'react';
import { useToastStore } from '../store/toastStore';

const typeStyles = {
  success: 'bg-mint text-white',
  error: 'bg-coral text-white',
  info: 'bg-tayo text-white',
};

export default function Toast() {
  const { message, type, visible, hideToast } = useToastStore();

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(hideToast, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible, hideToast]);

  if (!visible) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] animate-slide-down">
      <div className={`px-5 py-3 rounded-xl shadow-lg font-medium text-sm ${typeStyles[type] || typeStyles.info}`}>
        {message}
      </div>
    </div>
  );
}
